export default __webpack_public_path__ + "static/media/science-exact.37d81b6c.png";